var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { AnchoredLayer } from '@doordash/component-layer-manager';
import { SearchField } from '@doordash/component-fields';
import { Colors, Spacing } from '@doordash/design-language';
import Loading from '@doordash/component-loading';
import Tag from '@doordash/component-tag';
import * as React from 'react';
import styled from 'styled-components';
import { FilteredOptions } from './filtered_options';
export var SearchInputField = function (_a) {
    var onChange = _a.onChange, label = _a.label, _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c, _d = _a.placeholder, placeholder = _d === void 0 ? '' : _d, _e = _a.errorMessage, errorMessage = _e === void 0 ? '' : _e, _f = _a.isLoading, isLoading = _f === void 0 ? false : _f, _g = _a.noOptionsAvailable, noOptionsAvailable = _g === void 0 ? false : _g, _h = _a.noOptionText, noOptionText = _h === void 0 ? 'Nothing matches your search' : _h;
    return (React.createElement(SearchField, { autoFocus: true, autoComplete: "off", isDisabled: isLoading, "data-anchor-name": name, "data-anchor-id": "searchableSelectorSearchField", placeholder: placeholder, error: errorMessage, label: label, onChange: function (value) {
            onChange(value);
        }, value: value, renderAfterContent: function () {
            return isLoading ? (React.createElement(Loading, { size: Loading.Sizes.Small, color: Colors.SystemGrey70 })) : null;
        }, hint: noOptionsAvailable && !isLoading && Boolean(value) ? noOptionText : null }));
};
export var TagContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  margin: ", "px ", ";\n  & > div {\n    margin: ", " ", "px ", "px\n      ", ";\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  margin: ", "px ", ";\n  & > div {\n    margin: ", " ", "px ", "px\n      ", ";\n  }\n"])), Spacing.XxSmall, Spacing.None, Spacing.None, Spacing.XxSmall, Spacing.XxSmall, Spacing.None);
TagContainer.displayName = 'TagContainer';
export var TagSize;
(function (TagSize) {
    TagSize["Small"] = "Small";
    TagSize["Medium"] = "Medium";
    TagSize["Large"] = "Large";
})(TagSize || (TagSize = {}));
export var SelectedOptionsTag = function (_a) {
    var text = _a.text, onRemove = _a.onRemove, tagSize = _a.tagSize;
    return (React.createElement(Tag, { "data-anchor-id": "searchableSelectorTag", hasTrailingIcon: true, text: text, trailingIconAccessibilityLabel: "Remove tag", trailingIconType: Tag.IconTypes.Close, onTrailingClick: function () { return onRemove(); }, size: Tag.Sizes[tagSize] }));
};
export var SearchableOptionsSelectContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), function (_a) {
    var width = _a.width;
    return width;
});
SearchableOptionsSelectContainer.displayName =
    'SearchableOptionsSelectContainer';
export var SearchableOptionsSelect = function (_a) {
    var options = _a.options, placeholder = _a.placeholder, errorMessage = _a.errorMessage, label = _a.label, noOptionText = _a.noOptionText, searchText = _a.searchText, setSearchText = _a.setSearchText, clearSearchText = _a.clearSearchText, selectedOptions = _a.selectedOptions, onAddOption = _a.onAddOption, onRemoveOption = _a.onRemoveOption, name = _a.name, _b = _a.allowMultiSelect, allowMultiSelect = _b === void 0 ? true : _b, _c = _a.shouldAutomaticallyFlip, shouldAutomaticallyFlip = _c === void 0 ? false : _c, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d, _e = _a.width, width = _e === void 0 ? '500px' : _e, _f = _a.tagSize, tagSize = _f === void 0 ? TagSize.Small : _f;
    var selectedOptionsValues = React.useMemo(function () {
        return selectedOptions.map(function (_a) {
            var value = _a.value;
            return value;
        });
    }, [selectedOptions]);
    var noOptionsAvailable = options.length === 0;
    var onSelectOption = React.useCallback(function (option) {
        if (!selectedOptionsValues.includes(option.value)) {
            onAddOption(option);
        }
        else {
            onRemoveOption(option);
        }
    }, [selectedOptionsValues, onAddOption, onRemoveOption]);
    var focusEl = function () {
        var inputFields = document.querySelector("input[data-anchor-name=\"" + name + "\"]");
        if (!!inputFields &&
            typeof (inputFields === null || inputFields === void 0 ? void 0 : inputFields.focus) === 'function' &&
            !allowMultiSelect) {
            inputFields.focus();
        }
    };
    React.useEffect(focusEl, [selectedOptions]);
    React.useEffect(function () {
        if (!isLoading) {
            focusEl();
        }
    }, [isLoading]);
    return (React.createElement(SearchableOptionsSelectContainer, { width: width },
        React.createElement(AnchoredLayer, { shouldAutomaticallyFlip: shouldAutomaticallyFlip, position: AnchoredLayer.Positions.BottomCenter, content: Boolean(searchText) &&
                !isLoading && (React.createElement(FilteredOptions, { width: width, displayCheckmarkOnSelected: true, selectedOptionsValues: selectedOptionsValues, options: options, onSelect: function (option) {
                    onSelectOption(option);
                    !allowMultiSelect && clearSearchText();
                } })) },
            React.createElement(SearchInputField, { isLoading: isLoading, placeholder: placeholder, errorMessage: errorMessage, onChange: function (value) {
                    setSearchText(value);
                }, name: name, label: label, value: searchText, noOptionsAvailable: noOptionsAvailable, noOptionText: noOptionText })),
        React.createElement(TagContainer, { "data-anchor-id": "tagsContainer" }, selectedOptions.map(function (option) {
            return (React.createElement(SelectedOptionsTag, { key: option.value, text: option.text, onRemove: function () { return onRemoveOption(option); }, tagSize: tagSize }));
        }))));
};
export var SearchableDemo = function () {
    var OPTIONS = [
        { value: 'breakfast-id', text: 'breakfast', yolo: { level: 1 } },
        { value: 'lunch-id', text: 'lunch', yolo: { level: 1 } },
        { value: 'dinner-id', text: 'dinner', yolo: { level: 1 } },
    ];
    var _a = __read(React.useState(''), 2), searchText = _a[0], setSearchText = _a[1];
    var clearSearchText = React.useCallback(function () {
        setSearchText('');
    }, [setSearchText]);
    var _b = __read(React.useState([]), 2), selectedOptions = _b[0], setSelectedOptions = _b[1];
    var filteredOptions = React.useMemo(function () {
        return OPTIONS.filter(function (_a) {
            var text = _a.text;
            return text.toLowerCase().includes(searchText.toLowerCase());
        }).map(function (_a) {
            var text = _a.text, value = _a.value, other = __rest(_a, ["text", "value"]);
            return __assign(__assign({}, other), { value: value,
                text: text });
        });
    }, [searchText, OPTIONS]);
    var onAddOption = function (option) {
        setSelectedOptions(__spread(selectedOptions, [option]));
    };
    var onRemoveOption = function (option) {
        var newSelectedOptions = __spread(selectedOptions).filter(function (opt) {
            return opt.value !== option.value;
        });
        setSelectedOptions(newSelectedOptions);
    };
    return (React.createElement(SearchableOptionsSelect, { placeholder: 'what meal do you want?', noOptionText: 'No meal matches your search', errorMessage: '', isLoading: false, label: 'Select groups', width: '30vw', options: filteredOptions, searchText: searchText, clearSearchText: clearSearchText, setSearchText: setSearchText, selectedOptions: selectedOptions, onAddOption: onAddOption, onRemoveOption: onRemoveOption }));
};
var templateObject_1, templateObject_2;
